<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-10 18:23:30
-->
<template>
  <div class="page-main">
    <div class="page-type-switch">
      <div
        :class="pageType === 'cost-page' ? 'type-activite' : ''"
      >
        指标概览(养成)
      </div>
    </div>
    <ConstPage v-if="pageType === 'cost-page'" />
  </div>
</template>

<script>
import ConstPage from "./yc-quota-page.vue"
export default {
  name: "yc",
  data() {
    return {
      pageType: "cost-page",
    };
  },
  computed: {},
  components:{
    ConstPage
  },
  methods: {
    
  },
  mounted() {
    // 模板编译/挂载之后
  },
  // 数据监听
  watch: {
    
  },
};
</script>

<style lang="less" scoped>
</style>